shadow$provide[441] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform vec2 remapUVScale;

vec4 screenMapXY(vec4 uvwo, vec4 stpq) {
  return vec4(floor(remapUVScale * uvwo.xy), 0.0, 0.0);
}
`;

};